const Cookie = require('cookie');
const { isBrowser } = require('../utils/isBrowser');
const { COOKIES, SELLER_EXPERIENCE, PAYMENT_EXPERIENCE } = require('../constants');

const MOBILE_SIZE = 767;

const domainLookup = {
  'falabella-cl': '.falabella.com',
  'falabella-pe': '.falabella.com.pe',
  'falabella-co': '.falabella.com.co',
  'marketplace-cl': '.falabella.com',
  'marketplace-pe': '.falabella.com.pe',
  'marketplace-co': '.falabella.com.co',
  'sodimac-cl': '.sodimac.cl',
  'marketplacesodimac-cl': '.sodimac.cl',
  'sodimac-pe': '.sodimac.com.pe',
  'marketplacesodimac-pe': '.sodimac.com.pe',
  'sodimac-mx': '.sodimac.com.mx',
  'marketplacetottus-cl': '.tottus.cl',
  'tottus-cl': '.tottus.cl',
  'marketplacetottus-pe': '.tottus.com.pe',
  'tottus-pe': '.tottus.com.pe',
};

const sellerLookup = {
  'falabella-cl': 'marketplace-cl',
  'falabella-pe': 'marketplace-pe',
  'falabella-co': 'marketplace-co',
  'marketplace-cl': 'marketplace-cl',
  'marketplace-pe': 'marketplace-pe',
  'marketplace-co': 'marketplace-co',
  'sodimac-cl': 'marketplacesodimac-cl',
  'marketplacesodimac-cl': 'marketplacesodimac-cl',
  'sodimac-pe': 'marketplacesodimac-pe',
  'marketplacesodimac-pe': 'marketplacesodimac-pe',
  'marketplacetottus-cl': 'marketplacetottus-cl',
  'tottus-cl': 'marketplacetottus-cl',
  'marketplacetottus-pe': 'marketplacetottus-pe',
  'tottus-pe': 'marketplacetottus-pe',
};

const getCookie = (name, serverCookies = {}) => {
  if (isBrowser()) {
    const cookies = Cookie.parse(document.cookie);
    return cookies[name] || '';
  }
  const cookieValue = serverCookies[name] || '';
  try {
    return decodeURIComponent(cookieValue);
  } catch (error) {
    return cookieValue;
  }
};

function setCookie(
  name,
  value,
  tenantId,
  age = 0,
  isHighPriority = false,
  domainName = '',
  doEncode = true,
) {
  if (!isBrowser()) return;
  document.cookie = Cookie.serialize(name, value, {
    domain: domainName || domainLookup[tenantId],
    path: '/',
    maxAge: age || undefined,
    // https://github.com/jshttp/cookie#priority
    priority: isHighPriority ? 'high' : undefined,
    encode: doEncode ? undefined : (e) => e,
  });
}

function deleteCookie(name, tenantId, domainName) {
  if (!isBrowser()) return;
  document.cookie = Cookie.serialize(name, '', {
    domain: domainName || domainLookup[tenantId],
    path: '/',
    maxAge: 0,
    expires: new Date(1000),
  });
}

function deleteCookieWithoutDomain(name, options = {}) {
  if (!isBrowser()) return;

  const { sameSite } = options;

  const cookieOptions = {
    path: '/',
    maxAge: 0,
    expires: new Date(1000),
  };

  if (sameSite) {
    cookieOptions.sameSite = sameSite; // e.g., 'Strict', 'Lax', 'None'
  }

  document.cookie = Cookie.serialize(name, '', cookieOptions);
}

function setItemInSessionStorage(key, data) {
  window.sessionStorage.setItem(key, JSON.stringify(data));
}

function setItemInSessionStorageWithoutStringify(key, data) {
  window.sessionStorage.setItem(key, data);
}

function getItemInSessionStorage(key) {
  return window.sessionStorage.getItem(key);
}

function removeItemInSessionStorage(key) {
  window.sessionStorage.removeItem(key);
}

function getChannelId(channel) {
  if (!isBrowser()) {
    return channel;
  }
  const isMobile =
    window.matchMedia &&
    window.matchMedia(`(max-width: ${MOBILE_SIZE}px)`) &&
    window.matchMedia(`(max-width: ${MOBILE_SIZE}px)`).matches;
  if (isMobile) {
    return 'MOBILE';
  }
  return 'WEB';
}

function getEcommId(tenantId, additionalInfo = {}) {
  const { whitelabel = {} } = additionalInfo;
  if (whitelabel.enabled) {
    return whitelabel.ecommName;
  }
  if (getCookie(COOKIES.SELLER_EXPERIENCE) === SELLER_EXPERIENCE.MARKETPLACE) {
    return sellerLookup[tenantId];
  }
  return tenantId;
}

const isSeamlessPaymentEnabled = () =>
  getCookie(COOKIES.PAYMENT_EXPERIENCE) === PAYMENT_EXPERIENCE.SEAMLESS;

function setItemInLocalStorage(key, data) {
  window.localStorage.setItem(key, JSON.stringify(data));
}

function removeItemInLocalStorage(key) {
  window.localStorage.removeItem(key);
}

const getXCommerceValue = (url) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : url;
  const commerceMap = {
    'sodimac.cl': 'SOD',
    'sodimac.com.pe': 'SOD',
    'sodimac.com.mx': 'SOD',
    'tottus.cl': 'TOT',
    'tottus.com.pe': 'TOT',
  };

  for (const key in commerceMap) {
    if (origin.toString().includes(key)) {
      return commerceMap[key];
    }
  }
  return 'FCM';
};

module.exports = {
  setCookie,
  deleteCookie,
  getChannelId,
  setItemInSessionStorage,
  setItemInSessionStorageWithoutStringify,
  getCookie,
  getItemInSessionStorage,
  removeItemInSessionStorage,
  getEcommId,
  isSeamlessPaymentEnabled,
  setItemInLocalStorage,
  removeItemInLocalStorage,
  getXCommerceValue,
  deleteCookieWithoutDomain,
};
